module.exports = __webpack_public_path__ + "static/media/Mohamed Nazar.efefa4e7.jpeg";